import classNames from "classnames";
import { MouseEventHandler, ReactNode } from "react";
import { Link } from "react-router-dom";

import isExternal from "web/utils/data/validator/url/isExternal";

import defaultClasses from "./button.scss";

const Button = ({
  to = "",
  variant = "primary",
  size = "medium",
  block = false,
  transparent = false,
  type = "button",
  disabled = false,
  className = "", // Additional classnames to default styles
  onClick = undefined,
  children = "",
  dataT1 = "button",
  ariaLabel = undefined,
  target = undefined,
  rel = undefined,
}: {
  to?: string;
  variant?: "primary" | "secondary" | "tertiary" | "quaternary" | "text-button";
  size?: "thin" | "small" | "medium" | "large";
  block?: boolean;
  transparent?: boolean;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  className?: string;
  onClick?: MouseEventHandler<HTMLAnchorElement | HTMLButtonElement>;
  children?: ReactNode;
  dataT1?: string;
  ariaLabel?: string;
  target?: string;
  rel?: string;
}) => {
  const buttonClasses = classNames(
    defaultClasses.button,
    defaultClasses[variant],
    defaultClasses[size],
    {
      [defaultClasses.transparent]: transparent,
      [defaultClasses.block]: block,
      [defaultClasses.disabled]: disabled,
    },
    className
  );

  let buttonType: "button" | "submit" | "reset" = "button";
  if (type === "submit") {
    buttonType = "submit";
  } else if (type === "reset") {
    buttonType = "reset";
  }

  if (to && isExternal(to)) {
    return (
      <a
        href={to}
        onClick={onClick as MouseEventHandler<HTMLAnchorElement>}
        className={buttonClasses}
        data-t1={dataT1}
        target={target}
        rel={rel || (target === "_blank" ? "noopener noreferrer" : undefined)}
      >
        <span data-t1={`${dataT1}_span`}>{children}</span>
      </a>
    );
  }

  return to ? (
    <Link to={to} onClick={onClick} className={buttonClasses} data-t1={dataT1}>
      <span data-t1={`${dataT1}_span`}>{children}</span>
    </Link>
  ) : (
    <button
      // eslint-disable-next-line react/button-has-type
      type={buttonType}
      onClick={onClick}
      className={buttonClasses}
      disabled={disabled}
      data-t1={dataT1}
      aria-label={ariaLabel}
    >
      {children}
    </button>
  );
};

export default Button;
